import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';
import { PersistItemsReducer } from 'features/Persist/reducerTypes';
import { IdNameSymbolResponse } from 'services/tenantManagementService';
import { CURRENCIES_FETCHING, CURRENCIES_SET } from './action';

export const currencyReducer = (state = new PersistItemsReducer<IdNameSymbolResponse>(), action: PersistItemsActionType<IdNameSymbolResponse> | FetchingActionType): PersistItemsReducer<IdNameSymbolResponse> => {
	switch (action.type) {
		case CURRENCIES_FETCHING:
			const { fetching } = action as FetchingActionType;

			return {
				...state,
				fetching
			}
		case CURRENCIES_SET:
			const { items } = action as PersistItemsActionType<IdNameSymbolResponse>;

			const itemsMap: { [id: number]: IdNameSymbolResponse } = items.reduce(
                (map: { [id: number]: IdNameSymbolResponse }, item) => {
					map[item.id] = item;
					return map;
				},
                {}
			);

			return {
				items,
				itemsMap,
				fetching: false,
				isInitialized: true
			}
		default:
			return state;
	}
};
